import {
  amendmentCanBeRemoved,
  EditButtonFactory,
  getEditButtonType,
} from '@xemplo/amendment-details-modal';
import { useGetAmendmentByIdQueryV2 } from '@xemplo/amendment-query';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@xemplo/button';
import { PAYRUN_COMPONENTS } from '@xemplo/gp-constants';
import { DawnTrash } from '@xemplo/icons';
import { PayrunResubmitAmendment } from '@xemplo/payrun-resubmit-amendment';
import { Prompt } from '@xemplo/prompts';
import { RoleRenderer } from '@xemplo/role-renderer';
import { AuthorisationModule } from '@xemplo/role-types';
import { useRoleAuthorisation } from '@xemplo/roles-query';

import { useConfirmDeletePrompt } from './hooks/use-confirm-delete-prompt';
import * as S from './payrun-amendment-detail.styles';
import { PayrunAmendmentDetailFooterProps } from './payrun-amendment-detail.types';

export const PayrunAmendmentDetailFooter = (props: PayrunAmendmentDetailFooterProps) => {
  const { promptProps, promptVisible, setPromptVisible } = useConfirmDeletePrompt(props);
  const { data } = useGetAmendmentByIdQueryV2({ id: props.amendmentId });
  const { componentDisabled } = useRoleAuthorisation(AuthorisationModule.payrun);
  if (!data) return null;
  const editButtonType = getEditButtonType(data);

  return (
    <>
      <S.Footer>
        <EditButtonFactory
          type={editButtonType}
          amendmentId={props.amendmentId}
          onSubmitSuccess={props.onSuccess}
        />
        <RoleRenderer
          module={AuthorisationModule.payrun}
          component={PAYRUN_COMPONENTS.AMENDMENT_DELETE}
          additionalRules={[() => amendmentCanBeRemoved(data)]}
        >
          <Button
            ariaLabel="delete amendment"
            type={ButtonType.Tertiary}
            size={ButtonSize.Medium}
            onClick={() => setPromptVisible(true)}
            icon={<DawnTrash fontSize={24} />}
            disabled={componentDisabled(PAYRUN_COMPONENTS.AMENDMENT_DELETE)}
            variant={ButtonVariant.Error}
          >
            Remove
          </Button>
        </RoleRenderer>

        <PayrunResubmitAmendment
          onSuccess={props.onSuccess}
          amendmentId={props.amendmentId}
        />
      </S.Footer>
      <Prompt {...promptProps} open={promptVisible} />
    </>
  );
};
